/**
 * @generated SignedSource<<1d6cd987c5fc4856ac035f971838301c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationBokaklippDeleteMutation$variables = Record<PropertyKey, never>;
export type IntegrationBokaklippDeleteMutation$data = {
  readonly store: {
    readonly deleteIntegrationBokaklipp: boolean;
  };
};
export type IntegrationBokaklippDeleteMutation = {
  response: IntegrationBokaklippDeleteMutation$data;
  variables: IntegrationBokaklippDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleteIntegrationBokaklipp",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationBokaklippDeleteMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationBokaklippDeleteMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a0cada57433eefdcf1a80140c888ce3b",
    "id": null,
    "metadata": {},
    "name": "IntegrationBokaklippDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationBokaklippDeleteMutation {\n  store {\n    deleteIntegrationBokaklipp\n  }\n}\n"
  }
};
})();

(node as any).hash = "457eaeff1e8cb5b21229b442bbb0e4a8";

export default node;
